import { Button, Card, CardContent, CardMedia } from "../../../../../ui";
import styles from "./../../styles.module.scss";
import jira from "./../../../../../assets/jira-logo.png";
import { toast } from "react-toastify";
import { addOrUpdateConfigurations } from "../../../../../services/api/Configurations/ConfigurationService";
import { IConfiguration } from "../../../../../@types/configuration.type";
import { startProjectImport } from "../../../../../services/api/ProjectImport/ProjectImportService";

interface CardJiraProps {
  isJiraConfigured: boolean;
  configurations: IConfiguration[];
  setLoading: (loading: boolean) => void;
  handleOpen: () => void;
  showConfirm: () => Promise<unknown>;
  setIsJiraConfigured: (item: boolean) => void;
}

export function CardJira({
  isJiraConfigured,
  configurations,
  setLoading,
  handleOpen,
  showConfirm,
  setIsJiraConfigured
}: CardJiraProps) {
  
  const disconnectJira = async (): Promise<void> => {
    const isConfirm = await showConfirm();
    if (!isConfirm) return;

    try {
      setLoading(true);

      const configurationsToUpdate = configurations
        .filter(
          x =>
            x.key === "CONFIGURATION_JIRA_API_TOKEN" ||
            x.key === "CONFIGURATION_JIRA_EMAIL" ||
            x.key === "CONFIGURATION_JIRA_URL"
        )
        .map(config => ({
          ...config,
          value: "",
        }));

      await addOrUpdateConfigurations(configurationsToUpdate);

      setIsJiraConfigured(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  const syncronizeProjectWithJira = () => {
    setLoading(true);
    startProjectImport(2)
      .then(() => {
        setLoading(false);
        toast.success("Sincronização com convênia realizada com sucesso");
      })
      .catch(() => {
        toast.error("Falha na sincronização com o jira");
      });
  };
  

  return (
    <Card>
      <CardContent>
        <p>Sincronize seus projetos com o Jira</p>
        <CardMedia
          sx={{
            backgroundSize: "contain",
            margin: "15px 0",
            height: "100px",
          }}
          image={jira}
          title="jira"
        />

        <div className={styles.btnContainer}>
          {!isJiraConfigured ? (
            <div>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className={styles.btnConfigure}
                onClick={handleOpen}
              >
                Configurar
              </Button>
            </div>
          ) : (
            <div className={styles.btnsConnected}>
              <Button
                variant="outlined"
                color="primary"
                type="submit"
                className={styles.btnDisconnect}
                onClick={() => disconnectJira()}
              >
                Desconectar
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className={styles.btnSincronize}
                onClick={() => syncronizeProjectWithJira()}
              >
                Sincronizar agora
              </Button>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
